import env from "@/config/env"
import { ApiService } from "../base"

class JarvisService extends ApiService {
    constructor() {
        super({
            baseURL: `${env.JARVIS_API_PATH}`,
        })
    }
}

export default new JarvisService()
